import React, { Component } from 'react';

var clientImage = {
  backgroundImage: 'url(https://s3.amazonaws.com/uifaces/faces/twitter/kurtvarner/128.jpg)',
}

var userImage = {
  backgroundImage: 'url(https://s3.amazonaws.com/uifaces/faces/twitter/kfriedson/128.jpg)',
}


const ExampleComments = () =>
  <section id="comments">
    <h3 className="section-header">Comments</h3>
    <div className="row">
      <div className="columns small-16">
        <h4>Comment (not the logged-in user)</h4>        
        <div className="comment">
          <div className="row comment-wrapper">
            <div className="small-16 columns">
              <div className="timestamp">3 hours ago</div>
            </div>
            <div className="small-3 medium-2 columns">
              <div className="avatar avatar-round avatar-sm" style={clientImage}></div>
            </div>
            <div className="small-13 medium-6 columns">
              <div className="comment-text bubble-left">
                <h5>Client</h5>
                I really like the way this is looking. Can we try a different color?
              </div>
            </div>
          </div>
        </div>
        <h4>Comment in-place (not the logged-in user)</h4> 
        <div className="comment in-place">
          <div className="row comment-wrapper">
            <div className="small-16 columns">
              <div className="timestamp">3 hours ago</div>
            </div>
            <div className="small-3 medium-2 columns">
              <div className="avatar avatar-round avatar-sm" style={clientImage}></div>
            </div>
            <div className="small-13 medium-6 columns">
              <div className="comment-text bubble-left">
                <h5>Client</h5>
                Not sure about how the text here. Can we try it somewhere else?
                <div className="badge badge-default">1</div>
              </div>
            </div>
          </div>
        </div>
        <h4>Comment in-place active (not the logged-in user)</h4> 
        <div className="comment in-place active">
          <div className="row comment-wrapper">
            <div className="small-16 columns">
              <div className="timestamp">3 hours ago</div>
            </div>
            <div className="small-3 medium-2 columns">
              <div className="avatar avatar-round avatar-sm" style={clientImage}></div>
            </div>
            <div className="small-13 medium-6 columns">
              <div className="comment-text bubble-left">
                <h5>Client</h5>
                Not sure about how the text here. Can we try it somewhere else?
                <div className="badge badge-secondary">1</div>
              </div>
            </div>
          </div>
        </div>
        <h4>Comment (logged-in user)</h4> 
        <div className="comment current-user">
          <div className="row comment-wrapper">
            <div className="small-16 columns">
              <div className="timestamp">3 hours ago</div>
            </div>
            <div className="small-13 medium-6 columns">
              <div className="comment-text bubble-right">
                <h5>You</h5>
                Sure, I&apos;ll try blue.
              </div>
            </div>
            <div className="small-3 medium-2 columns">
              <div className="avatar avatar-round avatar-sm" style={userImage}></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>;

export { ExampleComments }



// WEBPACK FOOTER //
// ./styleguide/components/comments.jsx